module.exports = __webpack_public_path__ + "0b37e7e1c547ad1f8eeb929e90e69c62.png";